import { base, toJS } from '../../api/airtable.js'

const searchCheck = filter => query => 'AND(('+filter(query)+')>0,{Searchable})'

const matchAny = filters => query => filters.map(x => x(query)).join('+')

const matchCastNames = query => `FIND('${query.toLowerCase()}', LOWER(ARRAYJOIN({Cast Member Names},"")))`

const matchColumn = column => query => `FIND('${query.toLowerCase()}', LOWER({${column}}&""))`

const matchAll = cols => query => cols.map(matchColumn).map(x => x(query)).join('+')

const searchPatterns = {
  SEARCH_ALL: matchAny([matchAll(['Performance', 'Author Name', 'Title Name', 'Troupe Name']), matchCastNames]),
  SEARCH_AUTHOR: matchColumn('Author Name'),
  SEARCH_CAST: matchCastNames,
  SEARCH_TITLE: matchColumn('Title Name')
}

const state = {
  results: [],
  clean: true 
}

const getters = {}
const actions = {
  searchPerformances ({commit}, { query, searchType }) {
    const filter = searchCheck(searchPatterns[searchType])(query);
    console.log(filter)
    base('Performances').select({
      view: 'Grid view',
      filterByFormula: filter,
      sort: [
        {
          field: 'Year',
          direction: 'desc'
        }
      ]
    }).firstPage(function(err, records) {
      if(!err) {
        commit('SET_CLEAN', false)
        commit('SET_RESULTS', records.map(toJS))
      }
    })
  },
  clear({commit}) {
    console.log('cleaned!')
    commit('SET_CLEAN', true)
    commit('SET_RESULTS', [])
  }
}
const mutations = {
  SET_CLEAN (state, clean) {
    state.clean = clean
  },
  SET_RESULTS (state, performances) {
    state.results = performances;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
